<template>
  <v-container>
    <v-container>
      <v-row justify="center">
        <p>Experiment Completed. Thank you!</p>
      </v-row>
      <v-row justify="center">
        <v-btn :href="completionUrl" color="primary"
          >Click to submit <v-icon>chevron_right</v-icon></v-btn
        >
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
import { onMounted, ref } from "@vue/composition-api";
//import store from '@/store';
export default {
  setup() {
    const completionUrl = ref(null);
    onMounted(() => {
      window.onbeforeunload = null;
      completionUrl.value = "https://app.prolific.co/submissions/complete?cc=5EE58F8E";
      //completionUrl.value += store.state.pid;
    });

    return { completionUrl };
  },
};
</script>